import script from "./client-card-view.vue?vue&type=script&setup=true&lang=js"
export * from "./client-card-view.vue?vue&type=script&setup=true&lang=js"

import "./client-card-view.vue?vue&type=style&index=0&id=6872dd4a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6872dd4a"]])

export default __exports__